module.exports = __webpack_public_path__ + "static/img/26.43249c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/26.png
// module id = AP0q
// module chunks = 1